import * as Icons from "lucide-react";
import { TRUST } from "../../data/site";
import { Reveal } from "../motion";

export const TrustStrip = () => (
  <section aria-label="I nostri punti di forza" data-testid="trust-strip" className="border-b border-[color:var(--ngp-line)] bg-white">
    <div className="mx-auto grid max-w-[1440px] grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
      {TRUST.map((t, i) => {
        const Icon = Icons[t.icon] || Icons.Check;
        return (
          <Reveal key={t.title} delay={i * 0.08} className={`group flex gap-4 px-5 py-8 sm:px-8 lg:px-10 lg:py-10 ${i > 0 ? "border-t border-[color:var(--ngp-line)] sm:border-t-0 sm:[&:nth-child(n+3)]:border-t lg:[&:nth-child(n+3)]:border-t-0" : ""} ${i % 2 === 1 ? "sm:border-l sm:border-[color:var(--ngp-line)]" : ""} ${i === 2 ? "lg:border-l lg:border-[color:var(--ngp-line)]" : ""}`}>
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-[color:var(--ngp-line)] text-[color:var(--ngp-teal-ink)] transition-colors duration-300 group-hover:bg-[color:var(--ngp-teal)] group-hover:text-[color:var(--ngp-ink)]">
              <Icon size={20} strokeWidth={1.5} aria-hidden="true" />
            </span>
            <div>
              <h3 className="font-display text-lg font-semibold leading-tight">{t.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-[color:var(--ngp-muted)]">{t.text}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
